import { useDispatch } from '@bonanza-social/toolkit/state';
import { useNavigate } from 'react-router';
// import { openSocialRegistrationModal } from '../state/registrationForm/socialRegistrationForm.slice';
import { useEffect } from 'react';
import { logout } from '@bonanza-social/auth';

function LogOutPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(logout()).then(() => {
      navigate('/', { replace: true });
    });
  });

  return null;
}

export default LogOutPage;
